import "@babel/polyfill";
import React, { Component } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { Nav } from "./components";
import { firebase } from "./constants";
import Forgot from "./screens/auth/Forgot";
import SignIn from "./screens/auth/SignIn";
import Dashboard from "./screens/dash/Dashboard";
import Home from "./screens/home/Home";

class App extends Component {
  state = {
    authenticating: true,
    user: null,
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      this.setState({ authenticating: false, user });
    });
  }

  render() {
    if (this.state.authenticating) {
      return "Loading...";
    }

    return (
      <BrowserRouter>
        {this.state.user ? (
          <Switch>
            <Route
              path="/dashboard"
              render={(props) => (
                <Dashboard {...props} user={this.state.user} />
              )}
            />
            <Route render={() => <Redirect to="/dashboard" />} />
          </Switch>
        ) : (
          <div>
            <Nav />
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/forgot" component={Forgot} />
              <Route path="/signin" component={SignIn} />
              <Route render={() => <Redirect to="/" />} />
            </Switch>
          </div>
        )}
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js